import { NodeProps } from "reactflow";
import { CommandStep } from "app/lib/pipeline";
import BaseNode from "../BaseNode";
import Commands, { normalizeCommands } from "./Commands";
import Plugins from "./Plugins";
import ArtifactPaths from "./ArtifactPaths";
import { normalizePlugins, getDockerPlugin } from "app/lib/pipeline/plugins";

export default function CommandStepNode(props: NodeProps<CommandStep>) {
  const plugins = normalizePlugins(props.data.plugins);
  const docker = getDockerPlugin(plugins);
  const label = props.data.label || normalizeCommands(props.data).join(" && ");

  return (
    <BaseNode label={label} className="min-w-command-step-node p-6" {...props}>
      <Commands data={props.data} dockerImage={docker?.image} />
      <Plugins plugins={plugins} />
      <ArtifactPaths paths={props.data.artifact_paths} />
    </BaseNode>
  );
}
